export default __webpack_public_path__ + "static/media/full-logo.88083362.svg";